export default "__VITE_ASSET__CtqOknZZ__"